import React, { memo, Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import Paper from '@mui/material/Paper';
import WarningIcon from '@mui/icons-material/Warning';

import Alert from '../shared/Alert';

import { post } from '../../util/api';

import urls from '../../constants/urls';

import './dashboard.scss';

const DashboardMessage = ({ emailVerified, adminPassword, userData }) => {
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState('');
  const [alertType, setAlertType] = useState('success');

  const showVerificationMessage = !emailVerified;
  const showPendingAccessMessage = emailVerified && !userData?.role;

  const resendEmail = () => {
    post(urls.sendVerification, userData)
      .then(() => {
        setMessage('The link has been re-sent to your email');
        setAlertType('success');
        setAlert(true);
      })
      .catch((err) => {
        setAlertType('error');
        setMessage(err.message);
        setAlert(true);
      });
  };

  return (
    <Fragment>
      <Paper className="dashboard-message">
        {adminPassword && (
          <div className={`dashboard-warning-message${showVerificationMessage || showPendingAccessMessage ? ' with-spacing' : ''}`}>
            <WarningIcon htmlColor="#ee9321" />
            <span>You have default password set by admin. Please change to a new one.</span>
          </div>
        )}
        {showPendingAccessMessage && (
          <div>
            <div>We're currently confirming credentials and defining your user access.</div>
            <div>We'll notify you when your access is available.</div>
          </div>
        )}
        {showVerificationMessage && (
          <div>
            <div>A verification link has been sent to your email account.</div>
            <div>
              <p>Didn't receive the link or the link was expired?</p>
              <span onClick={resendEmail} className="resend-link">
                Resend
              </span>
            </div>
          </div>
        )}
      </Paper>
      <Alert variant={alertType} message={message} open={alert} onClose={() => setAlert(false)} />
    </Fragment>
  );
};

DashboardMessage.propTypes = {
  adminPassword: PropTypes.bool,
  emailVerified: PropTypes.bool,
  userData: PropTypes.object,
};

export default memo(DashboardMessage);
